module.exports = __webpack_public_path__ + "static/media/color-sharp.fa1f20cd.png";